module.exports = "https://p.cds.unp.clasificados.pe/book-claimer.405b4311c97910c4d3c7b2a2f92b84cc.jpg";